import React from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Euro, ArrowRight } from 'lucide-react';

const TalentExamplesSection = ({ talents, onContactClick }) => (
  <section className="py-12 sm:py-16 md:py-24 bg-white" id="talents" data-testid="talent-examples-section">
    <div className="max-w-6xl mx-auto px-3 sm:px-6 lg:px-8">
      <div className="text-center mb-8 sm:mb-16">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-display font-semibold text-tp-text mb-2 sm:mb-4">
          Exemples de profils disponibles
        </h2>
        <p className="text-sm sm:text-base text-tp-text-light max-w-2xl mx-auto">
          Des talents francophones qualifiés, prêts à rejoindre votre équipe
        </p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {talents.map((talent, index) => (
          <Card 
            key={talent.role} 
            className="p-4 sm:p-6 border-tp-border hover:border-tp-accent/30 hover:shadow-lg transition-all"
            data-testid={`talent-example-${index}`}
          >
            <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4">
              <div className="p-2 sm:p-3 rounded-lg bg-tp-bg flex-shrink-0">
                <talent.icon className="h-5 w-5 sm:h-6 sm:w-6 text-tp-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm sm:text-lg font-display font-semibold text-tp-text leading-tight line-clamp-2">{talent.role}</h3>
                <p className="text-xs text-tp-text-light mt-0.5 sm:mt-1">{talent.experience}</p>
              </div>
            </div>
            
            <div className="flex flex-wrap gap-1 sm:gap-1.5 mb-3 sm:mb-4">
              {talent.skills.slice(0, 4).map((skill) => (
                <span key={skill} className="px-1.5 sm:px-2 py-0.5 bg-tp-bg text-tp-text-light text-[10px] sm:text-xs rounded-full">
                  {skill}
                </span>
              ))}
            </div>
            
            <div className="pt-3 sm:pt-4 border-t border-tp-border flex items-center justify-between">
              <div className="flex items-center gap-1 sm:gap-1.5 text-xs sm:text-sm">
                <Euro className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-tp-accent" />
                <span className="font-semibold text-tp-text">{talent.costRange}</span>
                <span className="text-tp-text-light">/mois</span>
              </div>
              <Button variant="ghost" size="sm" onClick={onContactClick} className="text-tp-primary hover:bg-tp-bg text-xs sm:text-sm h-7 sm:h-8 px-2 sm:px-3">
                Demander
              </Button>
            </div>
          </Card>
        ))}
      </div>
      
      <div className="text-center mt-8 sm:mt-10">
        <p className="text-xs sm:text-sm text-tp-text-light mb-3 sm:mb-4">Vous cherchez un autre profil ?</p>
        <Button onClick={onContactClick} variant="outline" className="gap-2 border-tp-border text-tp-primary hover:bg-tp-bg text-sm">
          Décrivez votre besoin <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  </section>
);

export default TalentExamplesSection;
